import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  items: FAQItem[];
}

export default function FAQSection({ items }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
        >
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
          >
            <span className="font-medium text-foreground-900 text-sm pr-4">{item.question}</span>
            <span className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-300 ${
              openIndex === index ? 'rotate-180' : ''
            }`}>
              <i className="ri-arrow-down-s-line text-foreground-500"></i>
            </span>
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}